import { render, staticRenderFns } from "./statusPanelStyle.vue?vue&type=template&id=2224ceca&scoped=true"
import script from "./statusPanelStyle.vue?vue&type=script&lang=js"
export * from "./statusPanelStyle.vue?vue&type=script&lang=js"
import style0 from "./statusPanelStyle.vue?vue&type=style&index=0&id=2224ceca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2224ceca",
  null
  
)

export default component.exports